<template>
    <div class="cloud-performance-container">
        <div class="cloud-performance-png">
            <img :src="performanceItem.png" alt="" />
        </div>
        <div v-if="isCN" class="cloud-performance-title" :class="`title-${index}`">
            {{ $t(performanceItem.title) }}
        </div>
        <div v-else class="cloud-performance-title cloud-performance-entitle" :class="`title-${index}`">
            {{ $t(performanceItem.title) }}
        </div>
        <div class="cloud-performance-subtitle">
            <!-- <CommonComponentsTextWithCheckIcon> -->
            <div ref="subtitle" class="subtitle">
                {{ $t(performanceItem.subTitle) }}
            </div>
            <!-- </CommonComponentsTextWithCheckIcon> -->
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ifCNLocale } from '~~/composables/useLocale.ts';
    const isCN = ifCNLocale();

    defineProps<{
        performanceItem: FunctionTitle;
        index: number;
    }>();
    const subtitle = ref(null);

    onMounted(() => {
        // console.log(subtitle.value);
        // addTextScrollLine(subtitle.value);
        // addTextScrollLine('.subtitle');
        addCardJitter('.cloud-performance-container');
    });
</script>

<style lang="less" scoped>
    .cloud-performance-container {
        width: .convert(325px) [ @vw];
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        border-radius: .convert(20px) [ @vw];
        background-color: #161616;
        color: #fff;
        font-family: 'HarmonyOS Sans SC';
        font-style: normal;
        font-weight: 400;
        overflow: hidden;
        padding: .convert(62px) [ @vw] .convert(24px) [ @vw] .convert(35px) [ @vw] .convert(24px) [ @vw];
        @media (max-width: @screen-mobile-width) {
            width: .convert(160px) [ @vw-mobile];
            width: 100%;
            height: auto;
            border-radius: .convert(10px) [ @vw-mobile];
            padding: .convert(15px) [ @vw-mobile] .convert(15px) [ @vw-mobile] .convert(18px) [ @vw-mobile]
                .convert(15px) [ @vw-mobile];
        }

        .cloud-performance {
            &-png {
                display: flex;
                width: .convert(80px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    width: .convert(28px) [ @vw-mobile];
                    height: .convert(28px) [ @vw-mobile];
                }
                img {
                    width: 100%;
                }
            }

            &-title {
                font-family: Montserrat, 'HarmonyOS Sans SC';
                font-size: .convert(@font-size-title-lg) [ @vw];
                // font-style: normal;
                font-weight: 400;
                line-height: normal;
                min-height: .convert(150px) [ @vw];
                margin-top: .convert(32px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(24px) [ @vw-mobile];
                    margin-top: .convert(15px) [ @vw-mobile];
                }
            }
            &-entitle {
                font-size: .convert(36px) [ @vw];
            }
            &-subtitle {
                display: flex;
                .subtitle {
                    font-family: 'HarmonyOS Sans SC';
                    font-size: .convert(16px) [ @vw]; //16px
                    line-height: 160%;
                    font-weight: 400;
                    font-style: normal;
                    opacity: 0.8;
                    @media (max-width: @screen-mobile-width) {
                        font-size: .convert(12px) [ @vw-mobile];
                        width: .convert(123px) [ @vw-mobile];
                        margin-top: .convert(32px) [ @vw-mobile];
                    }
                }
            }
        }
    }

    :lang(en) {
        .cloud-performance-container {
            .cloud-performance {
                &-title {
                    font-size: .convert(36px) [ @vw];
                    @media (max-width: @screen-mobile-width) {
                        font-size: .convert(16px) [ @vw-mobile];
                    }
                }
                &-subtitle {
                    .subtitle {
                        margin-top: 1px;
                        @media (max-width: @screen-mobile-width) {
                            font-size: .convert(12px) [ @vw-mobile];
                        }
                    }
                }
            }
        }
    }
</style>
